import React from 'react';
import { motion } from 'framer-motion';
import { StarIcon } from 'lucide-react';
import { CTAButton } from './CTAButton';
const CART_URL = 'https://italia.kitonline.shop/cart/44568283611271:1';
export function Hero() {
  return <section className="pt-6 pb-8 px-4 relative overflow-hidden" data-id="element-163">
      <div className="max-w-md sm:max-w-lg mx-auto text-center relative z-10" data-id="element-164">
        <motion.div initial={{
        opacity: 0,
        y: -10
      }} animate={{
        opacity: 1,
        y: 0
      }} className="inline-flex items-center gap-2 bg-brand-card border border-brand-danger/40 px-4 py-1.5 rounded-full mb-5" data-id="element-165">
          <span className="w-2 h-2 rounded-full bg-brand-danger animate-pulse" data-id="element-166" />
          <span className="text-[11px] sm:text-xs font-black tracking-wider text-brand-danger uppercase" data-id="element-167">
            ATTENZIONE: DOCENTI DI ECONOMIA AZIENDALE STANCHI DI SACRIFICARE LE
            PROPRIE SERATE A PIANIFICARE
          </span>
        </motion.div>

        <motion.h1 initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        delay: 0.05
      }} className="text-[32px] sm:text-5xl font-black text-brand-cream leading-[1.05] mb-5" data-id="element-168">
          L'intero anno di{' '}
          <span className="bg-gradient-to-r from-brand-orange via-brand-amber to-brand-gold bg-clip-text text-transparent" data-id="element-169">
            Economia Aziendale
          </span>
          , pronto in{' '}
          <span className="bg-gradient-to-r from-brand-orange via-brand-amber to-brand-gold bg-clip-text text-transparent" data-id="element-170">
            5 minuti
          </span>
          .
        </motion.h1>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        delay: 0.1
      }} className="bg-brand-card border border-white/5 border-l-4 border-l-brand-orange rounded-xl p-4 sm:p-5 mb-6 text-left" data-id="element-171">
          <p className="text-base sm:text-lg text-gray-300 leading-snug" data-id="element-172">
            Il primo Metodo{' '}
            <span className="text-brand-orange font-bold" data-id="element-173">
              "Apri e Insegna"
            </span>{' '}
            con 6 volumi completi e materiali pronti per gli ITE.{' '}
            <span className="text-brand-cream font-bold" data-id="element-174">
              Recupera i tuoi weekend e entra in classe con l'autorevolezza che
              meriti.
            </span>
          </p>
          <p className="mt-3 text-xs sm:text-sm text-gray-500 font-bold uppercase tracking-wider" data-id="element-175">
            Metodo Economia Aziendale Pro™ — Sistema Didattico Integrato
          </p>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        delay: 0.15
      }} className="mb-6" data-id="element-176">
          <a href={CART_URL} className="block cursor-pointer" data-id="element-177">
            <img src="https://cdn.magicpatterns.com/uploads/cEHAGCX7qp4YzN5wCRyugj/my-project-page-1_(9).png" alt="Metodo Economia Aziendale Pro - Sistema Didattico Integrato" className="w-full h-auto object-contain drop-shadow-2xl" data-id="element-178" />
          </a>
        </motion.div>

        <motion.div initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} transition={{
        delay: 0.2
      }} className="flex flex-wrap items-center justify-center gap-x-2 gap-y-1 mb-3" data-id="element-179">
          <div className="flex shrink-0" data-id="element-180">
            {[...Array(5)].map((_, i) => <StarIcon key={i} className="w-5 h-5 text-brand-gold fill-current drop-shadow-[0_0_6px_rgba(251,191,36,0.6)]" data-id="element-181" />)}
          </div>
          <span className="text-sm font-bold text-brand-cream whitespace-nowrap" data-id="element-182">
            4.9/5 · +500 Recensioni Verificate
          </span>
        </motion.div>

        <motion.div initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} transition={{
        delay: 0.25
      }} className="inline-flex items-center gap-2 border border-brand-orange/40 bg-brand-orange/5 px-4 py-1.5 rounded-full mb-5" data-id="element-183">
          <span className="text-sm font-bold text-brand-orange whitespace-nowrap" data-id="element-184">
            🔥 47 docenti hanno scelto questo Metodo oggi
          </span>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 10
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        delay: 0.3
      }} data-id="element-185">
          <CTAButton href={CART_URL} className="w-full" data-id="element-186">
            SÌ! VOGLIO RECUPERARE IL MIO TEMPO
          </CTAButton>
        </motion.div>

        <div className="flex flex-wrap justify-center items-center gap-x-3 gap-y-1 mt-5 text-xs text-gray-400 font-medium" data-id="element-187">
          <span data-id="element-188">⚡ Accesso Immediato</span>
          <span className="text-gray-600" data-id="element-189">•</span>
          <span data-id="element-190">🛡️ Garanzia 14 Giorni</span>
          <span className="text-gray-600" data-id="element-191">•</span>
          <span data-id="element-192">💳 Pagamento Unico</span>
        </div>

        <div className="mt-6 flex flex-col items-center gap-2" data-id="element-193">
          <div className="w-10 h-10 rounded-full overflow-hidden border-2 border-white/30 shadow-lg" title="Italia" data-id="element-194">
            <img src="https://flagcdn.com/w160/it.png" alt="Italia" className="w-full h-full object-cover" data-id="element-195" />
          </div>
          <p className="text-[11px] text-gray-500 font-medium" data-id="element-196">
            🇮🇹 La risorsa N.1 scelta da oltre 800 docenti ITE in tutta Italia
          </p>
        </div>
      </div>
    </section>;
}